import React from 'react';
import { Switch as RNSwitch, SwitchProps as RNSwitchProps, View } from 'react-native';
import styled from 'styled-components/native';
import { useTheme } from '@theme/ThemeProvider';
import { Text } from './Text';

interface SwitchProps extends RNSwitchProps {
  label?: string;
  description?: string;
}

const Container = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-vertical: ${({ theme }) => theme.spacing.md}px;
`;

const LabelContainer = styled.View`
  flex: 1;
  margin-right: ${({ theme }) => theme.spacing.md}px;
`;

export const Switch: React.FC<SwitchProps> = ({ label, description, ...props }) => {
  const theme = useTheme();

  return (
    <Container>
      {label && (
        <LabelContainer>
          <Text variant="body" color="textPrimary">
            {label}
          </Text>
          {description && (
            <Text variant="caption" color="textSecondary" style={{ marginTop: 2 }}>
              {description}
            </Text>
          )}
        </LabelContainer>
      )}
      <RNSwitch
        trackColor={{
          false: theme.colors.neutral300,
          true: theme.colors.brandPrimary,
        }}
        thumbColor={theme.colors.surface}
        ios_backgroundColor={theme.colors.neutral300}
        {...props}
      />
    </Container>
  );
};
